var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-main"},[_vm._ssrNode("<div class=\"iframe-dom\""+(_vm._ssrStyle(null,{height: _vm.height }, null))+" data-v-500dc45e></div>")])
}
var staticRenderFns = []

export { render, staticRenderFns }